import { useIntl } from 'react-intl';
import { createFilters, FilterState, useTableFilter } from '@Component/Filter/utils';
import { dateUtil } from '@Util/date.ts';

export function useOverviewTableFilters(): FilterState {
    const intl = useIntl();

    return createFilters({
        searchFilter: useTableFilter({
            label: intl.formatMessage({ id: 'text_search' }),
            name: 'query',
            className: 'tsk-filter--width200px',
        }),
        periodFilter: useTableFilter({
            label: intl.formatMessage({ id: 'text_period' }),
            name: 'period',
            defaultValue: [
                dateUtil.formatDate(dateUtil.getFirstDayOfYear(new Date()), 'en', 'yyyy-MM-dd'),
                dateUtil.formatDate(dateUtil.getLastDayOfYear(new Date()), 'en', 'yyyy-MM-dd'),
                'Year',
            ],
        }),
        contentFilter: useTableFilter({
            label: intl.formatMessage({ id: 'tsk_salary_overview_view_mode' }),
            name: 'content',
        }),
        excludeReversedFilter: useTableFilter({
            label: intl.formatMessage({ id: 'tsk_excluse_reversed' }),
            name: 'excludeReversed',
        }),
    });
}
